"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MessageType_1 = __importDefault(require("./MessageType"));
const logger_1 = require("../utils/logger");
class MessageBroker {
    constructor() {
        this.name = 'ERR';
        this.role = 'ERR';
        this.room = 'ERR';
        this.participantKey = 'ERR';
        this.socket = null;
        this.messages = [];
        this.messageTypes = {};
        this.listeners = {};
        this.logger = new logger_1.Logger('MessageBroker', false);
    }
    on(event, cb) {
        const p = cb ? null : new Promise((resolve) => { cb = resolve; });
        const subscribers = this.listeners[event] || (this.listeners[event] = []);
        const subscriber = cb; // Make sure each element is unique
        subscribers.push(subscriber);
        const unsubscribe = () => {
            const index = subscribers.indexOf(subscriber);
            if (index != -1)
                subscribers.splice(index, 1);
        };
        return p ? p.finally(unsubscribe) : unsubscribe;
    }
    emit(event, ...params) {
        const subscribers = this.listeners[event];
        for (let i = 0; i < (subscribers || []).length; i++)
            subscribers[i](...params);
        return this;
    }
    update({ name, role, room, participantKey, socket }) {
        this.name = name;
        this.role = role;
        this.room = room;
        this.participantKey = participantKey;
        this.socket = socket;
    }
    addMessage(msg) {
        return this.addMessages('push', [msg]);
    }
    addMessages(method, messages) {
        switch (method) {
            case 'push':
                messages = this.messages.concat(messages);
                break;
            case 'unshift':
                messages = messages.concat(this.messages);
                break;
        }
        this.messages = messages;
        return this;
    }
    sendPeerMessage(message, to) {
        this.send({
            type: 'message--peer',
            recipient: to,
            message: JSON.stringify(message),
        });
    }
    sendRoleMessage(message, role) {
        this.send({
            type: 'message--role',
            role,
            message: JSON.stringify(message),
        });
    }
    sendRoomMessage(message) {
        this.send({
            type: 'message--room',
            message: JSON.stringify(message),
        });
    }
    sendCommand(command, to, args = '') {
        const message = {
            type: 'command',
            command,
            args, // argument
        };
        this.sendPeerMessage(message, to);
    }
    sendMessage(message, type = 'message', to = null) {
        const packagedMessage = { type, message };
        if (to) {
            this.sendPeerMessage(message, to);
            return;
        }
        this.sendRoomMessage(packagedMessage);
    }
    // Sender: participant_key
    // From: My ID
    // Name: my string name
    // Role: my user role (host/guest, etc)
    // Room: Room key (string ID for the room)
    // PeerKey: participant key (random string)
    addMyDataToMessage(message) {
        message.sender = this.participantKey;
        // message.name = this.name;
        // message.sender_role = this.role;
        // message.room = this.room_key;
        message.timestamp = Date.now();
        return message;
    }
    send(message) {
        message = this.addMyDataToMessage(message);
        this.socket.send(message);
    }
    // messages received from server
    handleReceiveData(rawData) {
        let data;
        this.logger.log('Receiving Message', rawData);
        if (typeof rawData === 'string') {
            data = JSON.parse(rawData);
        }
        else {
            data = rawData;
        }
        const messageTypes = this.messageTypes[data.type];
        if (messageTypes !== undefined) {
            messageTypes.forEach((mt) => mt.execute(data));
            return true;
        }
        this.emit('receivedUnhandledData', data);
        return false;
    }
    // register command
    registerNewMessageType(messageId, action) {
        const messageType = new MessageType_1.default(messageId, action);
        return this.registerMessageType(messageType);
    }
    // register command
    registerMessageType(messageType) {
        if (this.messageTypes[messageType.type] === undefined) {
            this.messageTypes[messageType.type] = [];
        }
        this.messageTypes[messageType.type].push(messageType);
        // allow chain pattern
        return this;
    }
}
const messageBroker = new MessageBroker();
exports.default = messageBroker;
